import { defaultTo, map, pipe, prop, renameKeys } from '@solta/ramda-extra'

export const mapToAddressViewModel = pipe(
  defaultTo({ searchDatum: [] }),
  prop('searchDatum'),
  map(renameKeys({ searchValue: 'propertyAddress' }))
)
